import { Theme } from '@mui/material';

// Interfaces
import { IStyles, ISxProps } from '../../../resource';

export type PreviewViewMode = 'default' | 'fullscreen' | 'mobile';

// Define styles
const styles: IStyles = {
  dialog: (theme) => ({
    position: 'relative',
    pt: theme.spacing(72),
    px: theme.spacing(24),
    pb: theme.spacing(24),
    backgroundColor: '#FFF',
    width: 1,
    height: 1,
    maxHeight: '100%',
    alignSelf: 'stretch',
    borderRadius: theme.spacing(24),
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'center',
    overflow: 'hidden',
    boxSizing: 'border-box',
  }),
  dialogFullscreen: (theme) => ({
    position: 'relative',
    pt: theme.spacing(72),
    px: theme.spacing(24),
    pb: theme.spacing(24),
    backgroundColor: '#FFF',
    width: 1,
    height: 1,
    maxHeight: '100%',
    alignSelf: 'stretch',
    borderRadius: 0,
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'center',
    overflow: 'hidden',
    boxSizing: 'border-box',
  }),
  dialogMobile: (theme) => ({
    position: 'relative',
    pt: theme.spacing(64),
    px: theme.spacing(12),
    pb: theme.spacing(12),
    backgroundColor: '#FFF',
    width: 390,
    maxWidth: '100%',
    height: 'min(844px, 100%)',
    alignSelf: 'center',
    borderRadius: theme.spacing(28),
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'center',
    overflow: 'hidden',
    boxSizing: 'border-box',
    boxShadow: '0 12px 40px rgba(0,0,0,0.25)',
  }),
  cdnWrapper: (() => ({
    flex: 1,
    minHeight: 240,
    overflow: 'hidden',
    width: '100%',
    maxWidth: '100%',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
  })),
  iframe: () => ({
    border: 0,
    width: '100%',
    height: '100%',
    flex: 1,
    minHeight: 240,
    display: 'block',
    backgroundColor: '#fff',
  }),
  status: () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 240,
    width: '100%',
  }),
  headerBtn: (theme) => ({
    color: theme.palette.secondary.main,
    '&.active': {
      color: theme.palette.secondary.main,
      bgcolor: theme.palette.secondary.light,
    },
    '& svg': {
      fontSize: 14,
      width: 14,
      height: 14,
    },
  }),
  phoneIcon: () => ({
    fontSize: 12,
    width: 12,
    height: 12,
  }),
  modalFullscreen: () => ({
    top: '0 !important',
    left: '0 !important',
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100% !important',
    '.MuiBackdrop-root': {
      top: '0 !important',
      left: '0 !important',
      right: 0,
      bottom: 0,
    },
  }),
  containerFullscreen: () => ({
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  }),
  containerMobile: () => ({
    top: 40,
    right: 24,
    bottom: 40,
    left: 24,
  }),
};

export const modalSxByMode: Record<PreviewViewMode, ISxProps<Theme> | undefined> = {
  default: undefined,
  fullscreen: styles.modalFullscreen,
  mobile: undefined,
};

export const containerSxByMode: Record<PreviewViewMode, ISxProps<Theme> | undefined> = {
  default: undefined,
  fullscreen: styles.containerFullscreen,
  mobile: styles.containerMobile,
};

// Export styles
export default styles;
